module.exports = __webpack_public_path__ + "static/media/media-entertainment.3ee68a62.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/svg/media-entertainment.svg
// module id = 3841
// module chunks = 0